
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_CHAIN = "SET_CHAIN";
export const SET_BALANCE = "SET_BALANCE";


export const setLanguage = (language = "en") => ({
  type: SET_LANGUAGE,
  language
});

export const setAccount = (account) => ({
  type: SET_ACCOUNT,
  account
});

export const setChain = (chain) => ({
    type: SET_CHAIN,
    chain
});

export const setBalance= (balance) => ({
  type: SET_BALANCE,
  balance
});